import Model from "~/models/_Model";
import dayjs from "dayjs";
import User from "~/models/User";
import { useForm } from "~/utils/useForm";

export default class Sync extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/schoology";
  }

  // Set the resource route of the model
  resource() {
    return "sync";
  }

  primaryKey() {
    return "id";
  }

  // Apply model instances to eager loaded relationships
  relations() {
    return {
      requested_by: User,
      //assignments: ComparisonAssignment,
      //scores: ComparisonScore,
    };
  }

  get sort_key() {
    return "";
    //return `${this.display_marking_periods}-${this.period}-${this.display_name}`;
  }

  get status_color() {
    switch (this.status) {
      case "success":
        return "positive";
      case "failed":
        return "negative";
      case "started":
        return "warning";
      default:
        return "info";
    }
  }

  get display_requested_by() {
    if (this.requested_by) {
      return this.requested_by.display_name;
    }
    return this.sync_tag ? this.sync_tag.split("-")[2] : "Unknown";
  }

  get display_available_at() {
    return this.formatDateTime(this.available_at);
  }
  get display_started_at() {
    return this.formatDateTime(this.started_at);
  }
  get display_completed_at() {
    return this.formatDateTime(this.completed_at);
  }
  get display_created_at() {
    return this.formatDateTime(this.created_at);
  }
  get display_updated_at() {
    return this.formatDateTime(this.updated_at);
  }

  formatDateTime(datevalue) {
    if (!datevalue) {
      return "";
    }
    return dayjs(datevalue).format("M/DD/YYYY h:mm:ss A");
  }

  static generateTeacherSyncForm(teacherUsername) {
    return new useForm(
      {
        sync_params: {
          sync_types: ["categories", "assignments", "scores"],
          sync_scope: "mp_teacher", // Current MP
          sync_key: teacherUsername,
          persist: true,
        },
      },
      {
        resetOnSuccess: true,
        useResource: Sync,
      }
    );
  }

  static generateSectionSyncForm(sectionKey) {
    return new useForm(
      {
        sync_params: {
          //sync_types: ["categories"],
          sync_types: ["categories", "assignments", "scores"],
          sync_scope: "section",
          sync_key: sectionKey,
          persist: true,
        },
      },
      {
        resetOnSuccess: true,
        useResource: Sync,
      }
    );
  }

  static generateAssignmentSyncForm(sectionKey, assignmentId) {
    return new useForm(
      {
        sync_params: {
          sync_types: ["assignments", "scores"],
          sync_scope: "section",
          sync_key: sectionKey,
          assignment_id: assignmentId,
          persist: true,
        },
      },
      {
        resetOnSuccess: true,
        useResource: Sync,
      }
    );
  }

  static generateScoresSyncForm(sectionKey, assignmentId) {
    return new useForm(
      {
        sync_params: {
          sync_types: ["assignments", "scores"],
          sync_scope: "section",
          sync_key: sectionKey,
          assignment_id: assignmentId,
          persist: true,
        },
      },
      {
        resetOnSuccess: true,
        useResource: Sync,
      }
    );
  }
}
